import React from 'react';
import { useApp } from '../../context/AppContext';
import { Apple, Youtube, Music, CheckCircle2, Clock } from 'lucide-react';
import { Badge } from '../ui/badge';

export default function GalleryView({ onSelect }) {
  const { filteredGuests, activeShow } = useApp();

  return (
    <div className="p-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 overflow-auto">
      {filteredGuests.map(g => (
        <div key={g.id} onClick={() => onSelect(g.id)} className="group bg-white rounded-lg border border-stone-200 overflow-hidden hover:shadow-lg transition-all cursor-pointer">
          <div className="aspect-square bg-stone-100 relative overflow-hidden">
            {g.thumbnail ? (
              <img src={g.thumbnail} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            ) : (
              <div className="w-full h-full grid place-items-center text-stone-300" style={{ background: `linear-gradient(135deg, ${activeShow.color}33, ${activeShow.color}11)` }}>
                <div className="text-5xl font-serif" style={{ color: activeShow.color }}>{g.name[0]}</div>
              </div>
            )}
            <div className="absolute top-2 right-2">
              {g.releaseStatus === 'signed' ? (
                <Badge className="bg-emerald-600 hover:bg-emerald-600 text-white text-[10px] gap-1"><CheckCircle2 className="w-3 h-3" />Signed</Badge>
              ) : (
                <Badge className="bg-amber-500 hover:bg-amber-500 text-white text-[10px] gap-1"><Clock className="w-3 h-3" />Pending</Badge>
              )}
            </div>
          </div>
          <div className="p-3">
            <div className="font-medium text-stone-900 text-[13.5px] truncate">{g.name}</div>
            <div className="text-[11.5px] text-stone-500 truncate mb-2">{g.role} • {g.company}</div>
            <div className="text-[12px] text-stone-700 line-clamp-2 mb-2.5 min-h-[32px]">{g.episodeTitle || 'Episode untitled'}</div>
            <div className="flex items-center justify-between">
              <div className="text-[11px] text-stone-500">{g.episodeDate || 'TBD'}</div>
              <div className="flex items-center gap-1.5">
                {g.platforms?.apple && <Apple className="w-3.5 h-3.5 text-stone-700" />}
                {g.platforms?.spotify && <Music className="w-3.5 h-3.5 text-emerald-600" />}
                {g.platforms?.youtube && <Youtube className="w-3.5 h-3.5 text-red-600" />}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
